import React from "../../__compat__/react/main.entry.mjs.mjs";
import { StyledTableFooter } from "./Table.styles.mjs.mjs";
import { TableContext } from "./Table.context.mjs.mjs";
export const TableFooter = React.forwardRef((props, ref) => {
    const tableContext = React.useContext(TableContext);
    return (React.createElement(StyledTableFooter, { ...props, ref: ref, role: "rowgroup", displayMode: tableContext.displayMode }, props.children));
});
TableFooter.displayName = 'TableFooter';
//# sourceMappingURL=TableFooter.mjs.mjs.map